import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class ViolatedFilenameFail extends UploadFail {
    static VIOLATED_FILENAME = 'violated_file_name';

    radarName = 'fail_{SOURCE}_violated-filename';
    message = `test`;
}
